export const CLICK_OUT = 'click_out';  // The user clicked somewhere outside of a target element or elements
export const START = 'start';
export const STOP = 'STOP';
export const TERMINATED = 'TERMINATED';
export const RUNNING = 'RUNNING';
export const COMPLETE = 'complete';
export const DISABLED = 'disabled';
export const INITED = 'inited';
export const CHANGE = 'change';
export const SELECT = 'select';
export const FAIL = 'FAIL';
export const READY = 'READY';
export const CLOSE = 'CLOSE';
export const OPEN = 'OPEN';
export const SKIPPED = 'skipped';
export const TASK_START = 'task_start';
export const TASK_END = 'task_end';
export const TASK_RECOVERY_POLICY_CONTINUE = 'TASK_RECOVERY_POLICY_CONTINUE';
export const TASK_RECOVERY_POLICY_FAIL = 'TASK_RECOVERY_POLICY_FAIL';

// HTTP Methods
export const GET = 'GET';
export const DELETE = 'DELETE';
export const POST = 'POST';
export const PUT = 'PUT';

// States
export const STATE_BOOT = 'state_boot';

// Asset Types
export const ASSET_TYPE = {
  'VIDEO': 'video',
  'IMAGE': 'image',
  'FILE': 'file'
}
